// components/FacebookPixel.tsx
import { useEffect } from 'react';
import Script from 'next/script';
import { marketingPermitido } from '@/lib/consentimento';

interface FacebookPixelProps {
  pixelId: string;
}

interface Window {
    fbq: (...args: any[]) => void;
}
  
declare global {
    interface Window {
        fbq: (...args: any[]) => void;
    }
}

const FacebookPixel: React.FC<FacebookPixelProps> = ({ pixelId }) => {
  useEffect(() => {
    if (!pixelId) {
      return;
    }

    // LGPD: sem consentimento de marketing o Pixel não envia dados
    window.fbq('consent', marketingPermitido() ? 'grant' : 'revoke');

    // Inicializando o Facebook Pixel
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }, [pixelId]);

  return (
    <>
      <Script
        id="facebook-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          `,
        }}
      />
      {/* sem <noscript>: sem JavaScript não há como pedir consentimento (LGPD) */}
    </>
  );
};

export default FacebookPixel;
